export const environment = {
    production: true,
    apiUrl: 'https://api.socialnetworkfinder.com/api',
    googleClientId: '427659148041-253dhlhlg3jv0a16srf4skkqk13ttqad.apps.googleusercontent.com',
    stripePublishableKey: 'pk_live_WuEq4h8go6sjSlmltNUVp3WC',
    squareApplicationId: '',
    squareLocationId: '',
    squareEnvironment: 'sandbox',
    // sentryEnv: 'prod',
    recaptchaSiteKey: '6Lfim1wtAAAAAGUxg1viJDRCRv-2Hs9BCpX9xdv_',
};
